import React, { Component } from 'react';
import Dropzone from './DropZone.js';
import Header from '../header';
class ImageCompare extends Component {
    constructor(props) {
        super(props)
        this.state={
            extend:"all"
        };
    }

    extendRight(){
        this.setState({
            extend:"right"
        });
    }
    extendLeft(){
        this.setState({
            extend:"left"
        });

    }
    extendEqual(){
        this.setState({
            extend:"all"
        });
    }
    render() {
    return (
        <div>
         <Header pagename="IMAGE COMPARISON"/>
        <div className="content ">
        
                  <Dropzone /> 
                  <div className="shadow content-comp">
                  
                   <div className="row">
                      
                       <div className={this.state.extend=="left"?"col-md-8 mr-0 pr-0 comp-b-r":this.state.extend=="right"?"col-md-4 mr-0 pr-0 comp-b-r":"col-md-6 mr-0 pr-0 comp-b-r"}>
                       
                        <img alt="demo" className="w-100" src="assets/media/logos/Image63.svg"/>
                       </div>
                       <div className={this.state.extend=="right"?"col-md-8 ml-0 pl-0":this.state.extend=="left"?"col-md-4 ml-0 pl-0":"col-md-6 ml-0 pl-0"}>
                       <div className="btn btn-primary comp-btn"><img className="comp-l" src="assets/media/logos/Icon-left.svg" alt="modelomage" title="left" onClick={() => this.extendRight()} /><span title="equal divide" onClick={() => this.extendEqual()}>M</span><img className="comp-r" title="right"  src="assets/media/logos/Icon-right.svg" alt="modelomage" onClick={() => this.extendLeft()}/></div>
                       <img alt="demo" className="w-100" src="assets/media/logos/Image63.svg" />         
                           </div>

                   </div>
                   
                  </div>
                  <div className="shadow content-comp">
                    <table>
                        <tr className="comp-tr">
                            <td className="td-h ">PRODUCT ID</td>
                            <td className="td-h ">PRODUCT IMAGE 1</td>
                            <td className="td-h ">PRODUCT IMAGE 2</td>
                            <td className="td-h ">MODEL</td>
                            <td className="td-h ">ALIGNED/NOT ALIGNED</td>
                            <td className="td-h ">CONFIDENCE %</td>
                            <td className="td-h">REPORT</td>
                        </tr>
                        <tr>
                            <td className="pr-9">P12345</td>
                            <td><img className="td-img" src="assets/media/logos/Image -1.svg" alt="modelomage"/></td>
                            <td><img className="td-img" src="assets/media/logos/Image -1.svg" alt="modelomage"/></td>
                            <td>ALIGNMENT</td>
                            <td>ALIGNED</td>
                            <td>98.50%</td>
                            <td><img src="assets/media/logos/pdf.svg"/></td>
                        </tr>
                    </table>
                   </div>
                  
        </div>
    </div>
    );
  }
}
  export default ImageCompare;